import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CoinsService_GetActiveMissionsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useIsMissionsActive} from '../../../features/Coins/utils/useIsMissionsActive';
import {MissionType} from './missionType';

/**
 * Returns the currently open missions that are displayed in the account area.
 */
export const useGetActiveMissions = () => {
  const isActive = useIsMissionsActive();
  const session = useFullSession();

  return useGrpcRequest(
    CoinsService_GetActiveMissionsLazy,
    {
      session: session!,
    },
    {
      disabled: !isActive || !session,
      mockData: async () => {
        return (
          await import('../__mocks__/getOpenMissions.mock')
        ).getOpenMissions();
      },
    },
  );
};

export const useGetActiveMissionByType = ({
  mission,
}: {
  mission: MissionType;
}) => {
  const {data} = useGetActiveMissions();
  return data?.missions.find(m => m.missionType?.$case === mission);
};
